import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IRuoloUor, IUor, IUser, IUserNotifications } from "../shared/interfaces";

const controller = 'RuoliUor';




const addRuoloUor = (aooId: number, ruoloUor: Partial<IRuoloUor>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/AddRuoloUor`, ruoloUor, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateRuoloUor = (aooId: number, ruoloUor: Partial<IRuoloUor>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/UpdateRuoloUor`, ruoloUor, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteRuoloUor = (aooId: number, ruoloUor: Partial<IRuoloUor>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/DeleteRuoloUor`, ruoloUor, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    addRuoloUor,
    updateRuoloUor,
    deleteRuoloUor,
}
